/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useState } from "react";
import { AddComponentButton } from "cms/components/layout/add-component/add-component-button";
import { AddComponentDialog } from "cms/components/layout/add-component/add-component-dialog";
import { AddInPlaceButton } from "cms/common/ui-components/add-in-place";

const AddComponent = (props) => {

    const { fieldName, isLineButton, position } = props;
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseAfterComponentAdded = () => {
        setTimeout(handleClose, 200);
    };

    const onClick = (e) => {
        setOpen(true);
        e.currentTarget.blur();
    };

    return (
        <>
            {isLineButton && <AddInPlaceButton onClick={onClick}/>}
            {!isLineButton && <AddComponentButton onClick={onClick} />}
            <AddComponentDialog
                componentPosition={position}
                fieldName={fieldName}
                handleCloseModal={handleCloseAfterComponentAdded}
                open={open}
                setOpen={setOpen}
            />
        </>
    );
};

export { AddComponent };
